/* Willington · carrito con la API Ajax de Shopify */
(function () {
  'use strict';

  var C = window.WL || {};
  var CART_JS = C.cartJs || '/cart.js';
  var CART_ADD = C.cartAdd || '/cart/add.js';
  var CART_CHANGE = C.cartChange || '/cart/change.js';
  var locale = String(C.locale || 'es').replace('_', '-');
  var fmt;
  try {
    fmt = new Intl.NumberFormat(locale, { style: 'currency', currency: C.currency || 'EUR' });
  } catch (e) {
    fmt = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' });
  }

  function money(cents) { return fmt.format(cents / 100); }
  function el(id) { return document.getElementById(id); }

  var panel = el('cart');
  var toggle = el('cartToggle');
  var list = el('cartList');
  var emptyMsg = el('cartEmpty');
  var countEl = el('cartCount');
  var totalEl = el('cartTotal');
  var noteEl = el('cartNote');
  var checkoutBtn = el('checkout');

  function getCart() {
    return fetch(CART_JS, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function postJson(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function showNote(text) {
    if (noteEl) { noteEl.textContent = text || ''; }
  }

  function openPanel() {
    if (!panel || !toggle) { return; }
    panel.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
  }

  function closePanel() {
    if (!panel || !toggle) { return; }
    panel.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
  }

  function optionsText(item) {
    if (item.product_has_only_default_variant || !item.options_with_values) { return ''; }
    return item.options_with_values.map(function (o) { return o.name + ' ' + o.value; }).join(' · ');
  }

  function render(cart) {
    if (!panel) { return; }
    list.innerHTML = '';
    cart.items.forEach(function (item) {
      var li = document.createElement('li');
      var name = document.createElement('span');
      name.textContent = item.product_title + ' × ' + item.quantity;
      var sub = document.createElement('small');
      var opts = optionsText(item);
      sub.textContent = (opts ? opts + ' · ' : '') + money(item.final_line_price);
      var rm = document.createElement('button');
      rm.type = 'button';
      rm.setAttribute('aria-label', 'Quitar ' + item.product_title);
      rm.textContent = '×';
      rm.addEventListener('click', function () {
        postJson(CART_CHANGE, { id: item.key, quantity: 0 })
          .then(function (r) { return r.json(); })
          .then(function (c) { render(c); })
          .catch(function () { showNote('No se pudo quitar el producto. Inténtalo de nuevo.'); });
      });
      li.appendChild(name);
      li.appendChild(sub);
      li.appendChild(rm);
      list.appendChild(li);
    });
    countEl.textContent = cart.item_count;
    totalEl.textContent = money(cart.total_price);
    emptyMsg.hidden = cart.items.length > 0;
    checkoutBtn.disabled = cart.items.length === 0;
    showNote('');
  }

  function refresh() {
    return getCart().then(render);
  }

  /* Color y talla: actualiza la variante y muestra la prenda por delante y por detrás */
  function parseJson(node) {
    if (!node) { return null; }
    try { return JSON.parse(node.textContent); } catch (err) { return null; }
  }

  function swapImage(scope, side, url) {
    var imgs = scope.querySelectorAll('[data-view="' + side + '"] img');
    for (var i = 0; i < imgs.length; i++) {
      imgs[i].removeAttribute('srcset');
      imgs[i].removeAttribute('sizes');
      if (url) { imgs[i].src = url; }
    }
  }

  function applyColor(form, input) {
    var scope = form.closest('.pdp') || form.closest('.card');
    if (!scope) { return; }
    var hex = input.getAttribute('data-hex');
    var dark = input.getAttribute('data-dark') === 'true';
    var shots = scope.querySelectorAll('.shot');
    for (var i = 0; i < shots.length; i++) {
      if (hex) { shots[i].style.setProperty('--tint', hex); }
      if (shots[i].classList.contains('tee') || shots[i].classList.contains('sweat')) {
        shots[i].classList.toggle('dark', dark);
        shots[i].classList.toggle('light', !dark);
      }
    }
    var views = parseJson(form.querySelector('[data-views]'));
    var view = views && views[input.value];
    if (view) {
      swapImage(scope, 'front', view.front);
      swapImage(scope, 'back', view.back);
    }
  }

  function syncVariant(form) {
    var variants = parseJson(form.querySelector('[data-variants]'));
    if (!variants) { return; }
    var sets = form.querySelectorAll('fieldset[data-option]');
    var chosen = [];
    for (var i = 0; i < sets.length; i++) {
      var on = sets[i].querySelector('input:checked');
      chosen.push(on ? on.value : null);
      var label = sets[i].querySelector('[data-opt-label]');
      if (label && on) { label.textContent = on.value; }
    }
    var match = null;
    for (var j = 0; j < variants.length; j++) {
      var ok = true;
      for (var k = 0; k < chosen.length; k++) {
        if (variants[j].options[k] !== chosen[k]) { ok = false; break; }
      }
      if (ok) { match = variants[j]; break; }
    }
    var hidden = form.querySelector('input[name="id"]');
    var btn = form.querySelector('button[type="submit"]');
    if (match && hidden) {
      hidden.value = match.id;
      if (btn) {
        btn.disabled = !match.available;
        btn.textContent = match.available ? btn.getAttribute('data-label') : 'Agotado';
      }
    } else if (btn) {
      btn.disabled = true;
      btn.textContent = 'No disponible';
    }
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('.add-form fieldset[data-option] input')) { return; }
    var form = input.closest('form');
    syncVariant(form);
    if (input.closest('[data-color-set]')) { applyColor(form, input); }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-add-form]')) { return; }
    var chosen = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]');
    if (!chosen || !panel) { return; }
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    if (btn) { btn.disabled = true; }

    postJson(CART_ADD, { id: Number(chosen.value), quantity: 1 })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (res) {
        return getCart().then(function (cart) {
          render(cart);
          if (!res.ok) {
            showNote(res.data.description || res.data.message || 'No se pudo añadir la prenda.');
          }
          openPanel();
        });
      })
      .then(function () {
        if (btn) { btn.disabled = false; }
        var pick = form.closest('details');
        if (pick) { pick.open = false; }
      })
      .catch(function () {
        if (btn) { btn.disabled = false; }
        form.submit();
      });
  });

  if (toggle && panel) {
    toggle.addEventListener('click', function () {
      if (panel.hidden) { openPanel(); } else { closePanel(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) { closePanel(); toggle.focus(); }
    });
    checkoutBtn.addEventListener('click', function () {
      window.location.href = '/checkout';
    });
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) { refresh().catch(function () {}); }
    });
    refresh().catch(function () {});
  }
})();
